export enum enumPhoneType {
    phnTypeUnknown = 0,
    phnTypeHome = 1,
    phnTypeHome2 = 2,
    phnTypeHomeFax = 3,
    phnTypeBusiness = 4,
    phnTypeBusiness2 = 5,
    phnTypeBusinessFax = 6,
    phnTypeMobile = 7,
    phnTypePagers = 8,
    phnTypeCarPhone = 9,
    phnTypeISDN = 10,
    phnTypeRented = 11,
    phnTypeContacts = 12,
    phnTypeBooking = 13,
    phnTypeOffice = 14,
    phnTypeFax = 15
}

export class Phone {
    public phoneId:     number;
    public phoneType:   enumPhoneType;
    public countryCode: string;
    public iddCode:     string;
    public areaCode:    string;
    public phoneNumber: string;
}
